import type { PortalResponse } from "./Portal.typed";
import type { PortalModel } from "./PortalModel";

export class PortalAdapter {
  private portalModel: PortalModel;

  constructor(portalModel: PortalModel) {
    this.portalModel = portalModel;
  }

  async getPortalCustomerInfo(token: string): Promise<PortalResponse> {
    return this.portalModel.getPortalCustomerInfo(token);
  }

  async updatePortalCustomerInfo(form: FormData, token: string): Promise<void> {
    return this.portalModel.updatePortalCustomerInfo(form, token);
  }
}
